<template>
  <v-card>
    <v-card-title>{{ dataProp.firstName }} {{ dataProp.lastName }}</v-card-title>
    <v-card-text>
      <FCCProperty :data="dataProp" dataKey="email" translation="competitor" />
      <FCCProperty :data="dataProp" dataKey="dateOfBirth" translation="competitor">
        <template v-slot:header>
          {{ dataProp['dateOfBirth'] | date }}
        </template>
      </FCCProperty>
      <FCCProperty :data="dataProp" dataKey="address" translation="competitor" />
      <FCCProperty :data="dataProp" dataKey="country" translation="competitor">
        <template v-slot:header>
          <flag :iso="dataProp['country']" class="mr-2" /> {{ dataProp['country'] }}
        </template>
      </FCCProperty>
      <FCCProperty :data="dataProp" dataKey="department" translation="competitor" />
      <FCCProperty :data="dataProp" dataKey="telephone" translation="competitor" />
      <FCCProperty :data="dataProp" dataKey="bestTime" translation="competitor" />
      <FCCProperty :data="dataProp" dataKey="shirtSize" translation="competitor" />
      <VAlert :value="checked" type="error" transition="scale-transition" >{{ $t("competitor.alreadyCheckedin") }}</VAlert>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="safety()" color="yellow">Safety sheet</v-btn>
      <v-btn @click="checkin()" color="green">Check-in</v-btn>
      <v-btn @click="resend()" color="yellow" v-if="!dataProp.emailConfirmed">Resend email</v-btn>
    </v-card-actions>
    <v-snackbar
      v-model="snackbar"
      :bottom="true"
      :timeout="5000">
      {{ snackbarMessage }}
      <v-btn
        color="red"
        @click="snackbar = false">
        {{ $t('ctrl.close') }}
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDataTable,
    VAlert,
    VSnackbar
  } from 'vuetify/lib'
  import FCCProperty from '../FCCProperty'
  import fccapi from "../../fccapi";
  import pdfmake from 'pdfmake';
  import fonts from '../../vfs_fonts.js';
  pdfMake.vfs = fonts;

  export default {
    name: 'FCCCompetitorDetails',
    data: () => ({
      checked: false,
      snackbar: false,
      snackbarMessage: ""
    }),
    props: {
      dataProp: Object,
      reload: Function
    },
    computed: {
      genders: function () { 
        return [this.$t("profile.male"), this.$t("profile.female")]
      }
    },
    components: {
        VCard,
        VTooltip,
        VForm,
        VTextField,
        VCardActions,
        VCardText,
        VSelect,
        VDataTable,
        FCCProperty,
        VAlert,
        VSnackbar
    },
    methods: {
      safety: function(){
        fccapi.get(`competitors/${this.$route.params.id}/safety/${this.$store.getters['competitionId']}`).then(d => {
          var docDefinition = d.data;
          var organizer = this.$store.getters['competition'].organizer;
          docDefinition.footer = (currentPage, pageCount, pageSize) => {
            return [
              {
                //text: "Organizator tekmovanja je\nProstovoljno gasilsko društvo Radovljica, Gorenjska cesta 31, 4240 Radovljica",
                text: "Competition organizer:\n"+organizer.longName+", "+organizer.address,
                alignment: 'center',
                margin: [20, -25, 20, 20]
              }
            ]
          };
          docDefinition.content.splice(-1, 1);
          var filename = this.dataProp.firstName + " " + this.dataProp.lastName + " safety sheet.pdf";
          pdfMake.createPdf(docDefinition).download(filename);
        })
      },
      checkin: function(){
        this.checked = false;
        fccapi.post(`competitors/${this.$route.params.id}/checkin/${this.$store.getters['competitionId']}`).then(d => {
          this.reload();
        }).catch(e => {
          console.log("Error"+e.response.status)
          if(e.response.status == 422)
          {
            this.checked = true;
          }
        })
      },
      resend: function() {
        console.log("Trying to resend confirmation email to " + this.dataProp.id);
        fccapi.post(`resend/${this.dataProp.id}/`).then(d => {
          this.snackbarMessage = "Confirmation email resent successfully";
          this.snackbar = true;
        }).catch(e => {
          this.snackbarMessage = "Failed to resend, code " + e.response.status;
          this.snackbar = true;
        })
      }
    }
  }
</script>
<style>
  .tag{
    width:130px;
    display:inline-block;
  }
</style>